import React, { Component } from 'react';
import { Card, Tag, Button, Dropdown, Menu, Icon } from 'antd';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class Positions extends Component {
    handleOption(value) {
        console.log(value);
        switch (value.key) {
            case 'delete-position':
                this.props.store.odysseyBotStore.deleteCurrentPosition();
                break;
            default:
            //noop
        }
    }

    render() {
        const {
            position,
            positionDetails,
            activeTradingSession
        } = this.props.store.odysseyBotStore;

        const winRate =
            (activeTradingSession.won /
                (activeTradingSession.trades - activeTradingSession.cancelled)) *
                100 || 0;

        if (!positionDetails || !position)
            return (
                <Card
                    title={'Position'}
                    bordered={false}
                    extra={
                        <span>
                            <b>Session:</b> {activeTradingSession.name} T:{' '}
                            {activeTradingSession.trades} W: {activeTradingSession.won} L:{' '}
                            {activeTradingSession.lost} W/R: {winRate.toFixed(2)}%
                        </span>
                    }
                >
                    No position open
                </Card>
            );

        const menu = (
            <Menu onClick={this.handleOption.bind(this)}>
                <Menu.Item key="delete-position">Delete Position</Menu.Item>
            </Menu>
        );
        return (
            <Card
                title={'Position'}
                bordered={false}
                extra={
                    <span>
                        <b>Session:</b> {activeTradingSession.name} T: {activeTradingSession.trades}{' '}
                        W: {activeTradingSession.won} L: {activeTradingSession.lost} W/R:{' '}
                        {winRate.toFixed(2)}%
                    </span>
                }
            >
                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th />
                            <th>Status</th>
                            <th>Symbol</th>
                            <th>Strategy</th>
                            <th>Qty</th>
                            <th>Entry Price</th>
                            <th>Exit Price</th>
                            <th>Stop Price</th>
                            <th>Margin</th>
                            <th>Fees</th>
                            <th>Unrealised P&L</th>
                            <th>Daily Realised P&L</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {positionDetails.side === 'BUY' ? (
                                    <i className={`fal fa-arrow-up success`} />
                                ) : positionDetails.side === 'SELL' ? (
                                    <i className={`fal fa-arrow-down error`} />
                                ) : null}
                            </td>
                            <td>
                                <Tag>{positionDetails.status}</Tag>
                            </td>
                            <td>{positionDetails.symbol}</td>
                            <td>
                                {positionDetails.entry_signal.strategyName
                                    ? `${positionDetails.entry_signal.strategyName} - ${positionDetails.entry_signal.signalGroupName}`
                                    : null}
                            </td>
                            <td>
                                {position.size}/{positionDetails.qty}
                            </td>
                            <td>
                                {(positionDetails.avg_entry &&
                                    positionDetails.avg_entry.toFixed(4)) ||
                                    positionDetails.entry_price.toFixed(4)}
                            </td>
                            <td>
                                <span>
                                    {(positionDetails.avg_exit &&
                                        positionDetails.avg_exit.toFixed(4)) ||
                                        (positionDetails.exit_price &&
                                            positionDetails.exit_price.toFixed(4)) ||
                                        '-'}
                                </span>
                            </td>
                            <td>
                                <span>{positionDetails.stop_loss.toFixed(4)}</span>
                            </td>
                            <td>
                                {position.position_margin} ({positionDetails.leverage}x)
                            </td>
                            <td>
                                <span className={positionDetails.fees > 0 ? 'error' : 'success'}>
                                    {positionDetails.fees.toFixed(8)}
                                </span>
                            </td>
                            <td>
                                <span className={positionDetails.pnl < 0 ? 'error' : 'success'}>
                                    {positionDetails.pnl.toFixed(8)}
                                    &nbsp;&nbsp; (
                                    {(
                                        (Math.abs(positionDetails.pnl) / position.position_margin) *
                                            100 || 0
                                    ).toFixed(2)}
                                    %)
                                </span>{' '}
                            </td>
                            <td>
                                <span className={position.realised_pnl < 0 ? 'error' : 'success'}>
                                    {position.realised_pnl.toFixed(8)}
                                </span>
                            </td>
                            <td>
                                <Dropdown overlay={menu}>
                                    <Button type="primary">
                                        Actions <Icon type="down" />
                                    </Button>
                                </Dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/TradeView/Positions.js